module.exports = __webpack_public_path__ + "static/media/p1_1.e5bf6cf6.png";